import { AuditLogFeed } from '@/features/recruitment/components/audit-log-feed';
import { AUDIT_FILTERS } from '@/features/recruitment/lib/audit-event-renderer';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

type FilterKey = (typeof AUDIT_FILTERS)[number]['key'];

const VALID_KEYS: FilterKey[] = AUDIT_FILTERS.map((f) => f.key);

interface AuditSearch {
  filter: FilterKey;
}

export const Route = createFileRoute('/recruitment/candidates_/$id/audit')({
  validateSearch: (search: Record<string, unknown>): AuditSearch => {
    const raw = typeof search.filter === 'string' ? search.filter : 'all';
    const filter = (VALID_KEYS as string[]).includes(raw) ? (raw as FilterKey) : 'all';
    return { filter };
  },
  component: AuditTab,
});

function AuditTab() {
  const { id } = Route.useParams();
  const { filter } = Route.useSearch();
  const navigate = useNavigate();

  const handleFilterChange = (key: string) => {
    const safe = (VALID_KEYS as string[]).includes(key) ? (key as FilterKey) : 'all';
    navigate({
      to: '/recruitment/candidates/$id/audit',
      params: { id },
      search: { filter: safe },
      replace: true,
    });
  };

  return <AuditLogFeed candidateId={id} filterKey={filter} onFilterChange={handleFilterChange} />;
}
